// console.log('custom.js');
$(function () {
  /*
  共通ヘッダー
  スクロールで、PCはメニュー表示(.js-topmenu)・SPはヘッダー縮小(.js-header)
  */
  $(window).scroll(function(){
    scroll = $(this).scrollTop();
    winW = $(window).width();
    if(winW > 960){
      target = $('.js-topmenu');
    }else{
      target = $('.js-header');
    }
    if(scroll >= 10){
      target.addClass('is-scroll');
    }else{
      target.removeClass('is-scroll');
    }
  });

  /*
  検索: クリアボタン
  */
  $('.js-search-clear').click(function(){
    $('.js-search-input').val('');
    $('.js-search-clear').fadeOut(300);
  });
  $('.js-search-input').on('keyup', function() {
    showClearBtn($(this));
    copyInputVal($(this));
  });
  $('.js-search-input').on('change', function() {
    showClearBtn($(this));
    copyInputVal($(this));
  });
  function showClearBtn($this){
    val = $this.val();
    if(val != ''){
      $this.next('.js-search-clear').fadeIn(300);
    }else{
      $this.next('.js-search-clear').fadeOut(300);
    }
  }
  //SP:ヘッダー内検索・ドロワー内検索に入力内容をセット
  function copyInputVal($this){ 
    val = $this.val();
    $('.js-search-input').val(val);
  }

  /*
  人気キーワード (PC:クイックサーチ)
  検索ボックス入力中はクイック検索結果が表示されるため、人気キーワードは非表示とする。
  */
  var $keywordslist = $('.quick-search .js-keywordslist');
  $('input.quick-search__input').keyup(function(){ //検索ボックス入力時
    if($('.quick-search__bar-inner').hasClass('active')){ //入力時にactiveクラスがついたら非表示
      $keywordslist.css('display','none');
    }else{
      $keywordslist.css('display','block');
    }
  });

  /*
  商品:SKUカート
  */
  // 開閉
  var skucart_scrollY = 0;
  $(document).on('click', '.js-skucart-open', function () {
    type = $(this).attr('data-type');
    target = $(this).parent('div').children('.js-skucart-wrap');
    skucart_scrollY = window.scrollY;
    // target.fadeIn(100);
    $('body').addClass('is-skucart-open');
    target.addClass('is-show');
    target.attr('data-type', type);
  }),
  $(document).on('click', '.js-skucart-close', function () {
    // $('body').removeClass('is-skucart-open');
    // $('html,body').scrollTop(skucart_scrollY);
    // $('.js-skucart-wrap').css('display', 'none');
    $('body').removeClass('is-skucart-open');
    $('html,body').scrollTop(skucart_scrollY);
    $('.js-skucart-wrap').removeClass('is-show');
  });

  // カート追加
  // 追加後はカートへ遷移せずその場に留まり、パネル内の結果バーに成否を表示する。
  // パネルは開いたままなので、続けて別カラー・別サイズを追加できる（複数購入導線）
  // 追加処理中の二重送信を防ぐ。処理中に再度押されても無視する
  var skucart_adding = false;

  // クリックされたボタンが属するパネルの結果バーに成否を表示する
  // （成功時はテーマ標準ポップアップを使うため、主にエラー表示用）
  function skucartShowResult($wrap, ok, message) {
    var $result = $wrap.find('.js-skucart-result');
    if (!$result.length) return;
    $result.prop('hidden', false).toggleClass('is-error', !ok);
    $result.find('.js-skucart-result-msg').text(message);
    // SKUカート下方のボタンから追加した場合でも気づけるよう、バーまでスクロール
    $result[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  /*
  ミニカート（テーマ標準の購入確認ポップアップ）
  テーマ内部のイベントバス(confirmation-popup:open)は外部から発火できないため、
  ヘッダーコンポーネントの購読処理と同じ手順を再現する。
  閉じる× と「ショッピングを続ける」(data-confirmation-close)・「カートを見る」は
  テーマ側の委譲ハンドラがそのまま効く。
  SPのタイムラグ対策として、クリックの瞬間にローディング状態で開き、
  追加完了後に中身を差し替える2段階にしている
  */
  var skucart_popup_timer = null;

  function skucartPopupParts() {
    var popup = document.querySelector('[data-purchase-confirmation-popup]');
    var container = popup ? popup.querySelector('[js-purchase-confirmation-container]') : null;
    if (!popup || !container) return null; // テーマ設定でポップアップ無効の場合は呼び出し元でフォールバック
    return { popup: popup, container: container };
  }

  // 自動クローズを予約する。マウスが乗っている間は閉じない（テーマ標準と同じ挙動）
  function skucartPopupArmClose(popup, delayMs) {
    function closePopup() { popup.classList.remove('active'); }
    window.clearTimeout(skucart_popup_timer);
    skucart_popup_timer = window.setTimeout(closePopup, delayMs);
    popup.addEventListener('mouseover', function () {
      window.clearTimeout(skucart_popup_timer);
      popup.addEventListener('mouseleave', closePopup, { once: true });
    }, { once: true });
  }

  // クリックの瞬間にローディング表示で開く
  function skucartPopupOpenLoading() {
    var parts = skucartPopupParts();
    if (!parts) return null;
    window.clearTimeout(skucart_popup_timer);
    parts.container.innerHTML =
      '<div class="custom-popup-loading">' +
      '<span class="custom-popup-loading__spinner" aria-hidden="true"></span>' +
      'カートに追加しています…' +
      '</div>';
    // ヘッダーより下までスクロールしていれば画面右上に固定（テーマと同じ判定）
    var rootStyle = getComputedStyle(document.documentElement);
    var headerHeight = (parseFloat(rootStyle.getPropertyValue('--height-header')) || 0)
                     + (parseFloat(rootStyle.getPropertyValue('--announcement-height')) || 0);
    parts.container.classList.toggle('fixed', window.scrollY > headerHeight);
    parts.popup.classList.add('active');
    return parts;
  }

  // 追加完了後、中身をテーマ標準セクションの内容へ差し替える
  function skucartPopupFill(parts, itemKey) {
    fetch('/cart/?section_id=purchase-confirmation-popup-item')
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        // 送料無料バーはテーマJSの初期化（外部から呼べない）が必要なため取り除く
        tmp.querySelectorAll('.free-shipping-bar').forEach(function (el) {
          el.remove();
        });
        parts.container.innerHTML = tmp.innerHTML;

        // セクションは全カート行をhiddenで描画する。今追加した行だけ表示する
        if (itemKey) {
          var row = parts.container.querySelector('[data-product-key="' + itemKey + '"]');
          if (row) row.classList.remove('hidden');
        }

        // 自動クローズまでの表示時間。テーマ標準は5秒だが、SPはホバーで
        // 一時停止できず読み切れないため8秒に延長（2026-09-09 家崎代表要望）
        skucartPopupArmClose(parts.popup, 8000);
      })
      .catch(function () {
        // 追加自体は成功している。中身の取得に失敗した場合は簡易表示に切り替える
        skucartPopupMessage(parts, 'カートに追加しました');
      });
  }

  // エラー等の簡易メッセージ表示
  function skucartPopupMessage(parts, message) {
    var p = document.createElement('p');
    p.className = 'custom-popup-message';
    p.textContent = message;
    parts.container.innerHTML = '';
    parts.container.appendChild(p);
    skucartPopupArmClose(parts.popup, 8000);
  }

  // 動的に挿入されるグリッド（最近見た商品等）にも効くよう委譲で束ねる
  $(document).on('click', '.js-skucart-addcart', function(){
    if (skucart_adding) return;
    skucart_adding = true;
    $('.js-skucart-addcart').attr('aria-busy', 'true');

    var $wrap = $(this).closest('.js-skucart-wrap');
    // クリックの瞬間にローディングのポップアップを開く（SPでも体感ゼロ待ち）
    var popupParts = skucartPopupOpenLoading();

    var formData = {
      'items': [{
      'id': $(this).data('variant-id'),
      'quantity': 1
      }]
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(function (response) {
      return response.json().then(function (json) {
        return { ok: response.ok, json: json };
      });
    })
    .then(function (result) {
      if (result.ok) {
        // ミニカートに追加内容を表示（ポップアップ無効時はパネル内バーへフォールバック）
        var addedItem = result.json.items && result.json.items[0];
        if (popupParts) {
          skucartPopupFill(popupParts, addedItem ? addedItem.key : null);
        } else {
          skucartShowResult($wrap, true, 'カートに追加しました');
        }
        // ヘッダーのカート数を更新（テーマがこのDOMイベントを購読している）
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
        // 特典ガード(custom-gift-guard.js)に判定させる。閾値到達なら
        // カート到達前にこの場でエコバッグが付与・是正される
        document.dispatchEvent(new CustomEvent('cart:item-added'));
      } else {
        // Shopify側エラー（在庫切れ等）。descriptionにユーザー向け文言が入る
        var errMessage = result.json.description || 'カートに追加できませんでした。時間をおいて再度お試しください';
        if (popupParts) skucartPopupMessage(popupParts, errMessage);
        else skucartShowResult($wrap, false, errMessage);
      }
    })
    .catch(function (error) {
      console.error('カート追加でエラーが発生しました:', error);
      var netMessage = '通信エラーでカートに追加できませんでした。再度お試しください';
      if (popupParts) skucartPopupMessage(popupParts, netMessage);
      else skucartShowResult($wrap, false, netMessage);
    })
    // 成否にかかわらずロックを解除し、続けて追加できる状態へ戻す
    .then(function () {
      skucart_adding = false;
      $('.js-skucart-addcart').removeAttr('aria-busy');
    });
  });

  /*
  ブラウザバック（スマホのフリックを含む）からの復帰処理
  「戻る」ではサーバーに問い合わせず、前回そのページを開いた時のHTMLが
  そのまま表示される（実測: 転送サイズ0）。bfcacheから復元される場合も
  DOMが離脱時のまま。いずれも画面のカート情報が古くなるため、
  復帰を検知して実際のカートと突き合わせる
  */
  function isRestoredNavigation(event) {
    if (event && event.persisted) return true; // bfcache（JSごと保持）
    if (performance.getEntriesByType) {
      var nav = performance.getEntriesByType('navigation')[0];
      if (nav) return nav.type === 'back_forward'; // 戻る/進む（HTMLはキャッシュ）
    }
    // 古いiOS Safari向けの旧API（2 = TYPE_BACK_FORWARD）
    return !!(performance.navigation && performance.navigation.type === 2);
  }

  // カートページは点数だけでなく明細も古くなる。描画時点の点数（Liquidが埋めた
  // data-cart-rendered-count）と実際のカートが食い違うときだけ取り直す。
  // 一致していれば何もしないので、通常は余計な待ち時間は発生しない
  function refreshCartPageIfStale() {
    var cartRoot = document.querySelector('[data-cart-rendered-count]');
    if (!cartRoot) return; // カートページ以外
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (String(cart.item_count) !== cartRoot.getAttribute('data-cart-rendered-count')) {
          location.reload();
        }
      })
      .catch(function () {});
  }

  window.addEventListener('pageshow', function (event) {
    // bfcache復元だと離脱時に立てた送信中フラグが残ったまま画面が戻り、
    // 以降クリックが全て無視される。復元時に必ずロックを解除する
    skucart_adding = false;
    $('.js-skucart-addcart').removeAttr('aria-busy');

    if (!isRestoredNavigation(event)) return;
    fixCartCount();          // ヘッダー・SP下部メニューのカゴ数を実カートに合わせる
    refreshCartPageIfStale(); // カートページなら中身ごと取り直す
  });

  /*
  カゴ数の補正
  ヘッダーのカゴ数はエコバッグ（特典）を除いた「購入する商品の数量」を表示する。
  初期表示は Liquid（snippets/custom-cart-count.liquid）で除外済みだが、
  テーマJSと特典ガードはカート更新時に cart.item_count をそのまま書き込むため、
  書き込みを検知して除外後の数へ書き直す。除外対象は Liquid 側と一致させること
  */
  var COUNT_EXCLUDE_HANDLES = ['eco-bag'];
  var cartcount_els = document.querySelectorAll('[data-js-cart-count]');
  var cartcount_timer = null;

  function fixCartCount() {
    window.clearTimeout(cartcount_timer);
    cartcount_timer = window.setTimeout(function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var count = cart.item_count;
          cart.items.forEach(function (item) {
            if (COUNT_EXCLUDE_HANDLES.indexOf(item.handle) !== -1) count -= item.quantity;
          });
          cartcount_els.forEach(function (el) {
            // 同値なら書き込まない（Observerの再発火＝無限ループを断つ）
            if (el.textContent.trim() !== String(count)) el.textContent = count;
          });

          // SP下部メニューのバッジ。</header> の外にあるためテーマの更新対象外で、
          // 何もしないとページ読み込み時の値のまま固まる。ここで同じ数に合わせる。
          // 要素はセクション再描画で差し替わりうるため都度取り直す
          var btmIcon = document.querySelector('[data-js-btmmenu-cart]');
          if (btmIcon) {
            var btmCount = btmIcon.querySelector('._count');
            btmIcon.classList.toggle('is-active', count > 0);
            if (btmCount) {
              if (btmCount.textContent.trim() !== String(count)) btmCount.textContent = count;
              btmCount.hidden = count <= 0;
            }
          }
        })
        .catch(function () {});
    }, 200);
  }

  if (cartcount_els.length && window.MutationObserver) {
    var cartcount_observer = new MutationObserver(function () {
      fixCartCount();
    });
    cartcount_els.forEach(function (el) {
      cartcount_observer.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  /*
  SP:下部固定メニュー 探す
  */
  $('.js-btmmenu-search').click(function(){
    $(this).toggleClass('is-open');
    $('.js-menudrawer').toggleClass('is-open');
    $('html,body').toggleClass('is-menudrawer-open');
    $('.js-header').toggleClass('is-menudrawer-open');
    if($(this).hasClass('is-open')){
      $('.js-btmmenu-search ._label').html('閉じる');
    }else{
      $('.js-btmmenu-search ._label').html('探す');
    }
  });
  /*
  SP:下部固定メニュー キーワード検索
  */
  $('.js-menudrawer-form').click(function(){
    $('.js-searchdrawer').addClass('is-open');
    $('.js-searchdrawer .js-search-input').focus();
  });
  $('.js-searchdrawer-close').click(function(){
    $('.js-searchdrawer').removeClass('is-open');
  });
  /*
  SP:下部固定メニュー お気に入りアイコン class付与
  */
  var interval = setInterval(() => {
    var badge = $('.js-btmmenu-wishlist .topbadge');
    if (badge.length > 0) {
      var badgeText = badge.text().trim();
      if(badgeText != ''){
        $('.js-btmmenu-wishlist ._icon').addClass('is-active');
      }
      clearInterval(interval);
    }
  }, 100);
  /*
  SP:下部固定メニュー 検索履歴
  */
  var cookie_name = 'searchHistory';
  var max_history = 4;
  displayHistory();
  // Enterキー押下
  $('.js-search-input').on('keypress', function(e) {
    if (e.which === 13) {
      var searchWord = $(this).val().trim();
      if (searchWord) {
        saveHistory(searchWord);
      }
    }
  });
  // 履歴保存
  function saveHistory(searchWord) {
    var history = $.cookie(cookie_name) ? JSON.parse($.cookie(cookie_name)) : [];
    history = history.filter(word => word !== searchWord); //重複削除
    history.unshift(searchWord); //追加
    if (history.length > max_history) { //件数チェック・削除
      history.pop();
    }
    $.cookie(cookie_name, JSON.stringify(history), { expires: 7, path: '/' }); //保存
  }
  // 履歴表示
  function displayHistory() {
    var history = $.cookie(cookie_name) ? JSON.parse($.cookie(cookie_name)) : [];
    var historyList = $('.js-search-historylist');
    historyList.empty();
    if(history.length > 0){
      history.forEach(word => {
        tag = '';
        tag += '<li>';
        tag += `<a href="/search?q=${word}&type=product&options%5Bprefix%5D=last">`;
        tag += '<span class="_icon"><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.165 18.808a8.745 8.745 0 1 0 0-17.49 8.745 8.745 0 0 0 0 17.49z" stroke="currentColor" stroke-width="1.6" stroke-miterlimit="10" stroke-linecap="round"></path><path d="m16.5 16.5 5.363 5.362" stroke="currentColor" stroke-width="1.6" stroke-miterlimit="10"></path></svg></span>';
        tag += word;
        tag += '</a>';
        tag += '</li>';
        historyList.append(tag);
      });
    }else{
      $('.js-search-history').css('display', 'none');
    }
  }

});
